export default {
  "content": "<g clip-path=\"url(#clip0_807_13546)\"><path d=\"M15.333 2H.667A.667.667 0 000 2.667v8.666A.667.667 0 00.667 12H11.24l2.287 2.453a.666.666 0 001.14-.506V12h.666a.666.666 0 00.667-.667V2.667A.666.666 0 0015.333 2zm-6 7.333H2.667a.667.667 0 110-1.333h6.666a.667.667 0 010 1.333zm4-3.333H2.667a.667.667 0 010-1.333h10.666a.667.667 0 110 1.333z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_807_13546\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};